import React from 'react';
import { luxColors } from '@alucio/lux-ui';
const useStyles = {
    errorContainer: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    errorText: {
        backgroundColor: luxColors.basicBlack.primary,
        color: luxColors.info.primary,
        padding: 15,
        // eslint-disable-next-line max-len
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif',
        fontSize: 14,
        fontWeight: 500,
        opacity: 0.8,
    },
};
export default function BandwidthWarning() {
    const classes = useStyles;
    return (React.createElement("div", { 
        // @ts-ignore
        style: classes.errorContainer },
        React.createElement("div", null),
        React.createElement("div", { style: classes.errorText }, "Insufficient Bandwidth")));
}
//# sourceMappingURL=BandwidthWarning.js.map